import { Container, Stack } from "@mui/material";
import React from "react";
import { navigate } from "gatsby";
import COLORS from "../../constants/colors";
import HordeLogo from "../../assets/svgs/horde-h.svg";
import { clearSessionStorage } from "../../services/accessTokenHandler";
import { clearLoanType } from "../../utils/loanTypeHandler";

interface Props {
  children: React.ReactNode;
  bgColor?: string;
  showLogo?: boolean;
}
const LoanApplicationLayout = ({
  children,
  bgColor = COLORS.BRIGHT_BLUE[40],
  showLogo = true,
}: Props) => {
  return (
    <Stack
      component="main"
      bgcolor={bgColor ?? COLORS.BRIGHT_BLUE[40]}
      minHeight="100lvh"
      gap="8px"
    >
      <Container maxWidth="xl">
        <Stack
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              clearSessionStorage();
              clearLoanType();
              navigate("/");
            }
          }}
          direction="row"
          justifyContent="flex-start"
          pt="15px"
          sx={{ cursor: "pointer" }}
          onClick={() => {
            clearSessionStorage();
            clearLoanType();
            navigate("/");
          }}
        >
          {showLogo && <HordeLogo />}
        </Stack>
      </Container>
      {children}
    </Stack>
  );
};
export default LoanApplicationLayout;
